export const getLov = `
  query MyQuery($hotelId: String!, $lang: String!, $listName: String!) {
    getLov(input: {hotelId: $hotelId, lang: $lang, listName: $listName}) {
      hotelId
      lists {
        languages {
          lang
          values {
            id
            name
          }
        }
        listName
      }
    }
  }
`;
